export enum ScheduleModeEnum {
  SCHEDULED,
  ALWAYS_ACTIVE,
}
